module.exports = {
  InputText: {
    PluginName: "Kullanıcı Girişi",
    content_box_name: "İçerik ",
    fontSize: "Font Genişiği",
    answerType: "Cevap Türü",
    Precision: "Hataya İzin Verilir",
    Placeholder: "İstenen cevabı yaz",
    Characters: "Büyük / küçük harf ve özel karakterleri yok say",
    General: "Gelişmiş",
    text: "Yazı",
    number: "Sayı",
    notCount: "Bu soru puan eklemez",
  },
};
